<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-08-18 14:45:07
-->
<template>
	<div>
		<div class="flex flex-align-center">
			<div :class="['state_icon', statusClass]"></div>
			<div class="ml-10 ml-6">{{ row.promote_status_text }}</div>
		</div>
	</div>
</template>
<script>
import mixin from './mixin';
export default {
	mixins: [mixin],
	computed: {
		statusClass({ row }) {
			const { promote_status } = row;
			let obj = {
				'1': 'success',
				'5': 'warning',
			};
			return obj[promote_status] || 'danger';
		},
	},
};
</script>
<style lang="less" scoped>
.state_icon {
	width: 8px;
	height: 8px;
	border-radius: 50%;
}
.success {
	background-color: @color-success;
}
.danger {
	background-color: @color-danger;
}
.warning {
	background-color: @color-warning;
}
</style>
